import type { PageComponentProps } from '@/features/a-dynamic-page/components/page-component-switch';
import type { MapButtonStickyV1Attributes } from '@/features/map/map-button-sticky-v1/map-button-sticky-v1-type';

import { useLayoutId } from '@/core/features/app/app-atoms';
import { triggerAppBottomSheet } from '@/core/features/native-app-bridge/native-app-bridge-service';
import MapButtonSticky from '@/features/map/map-button-sticky-v1/map-button-sticky';

export default function MapButtonStickyV1({ attributes }: PageComponentProps<MapButtonStickyV1Attributes>) {
    const { iconUrl, linkUrl, title } = attributes;
    const layoutId = useLayoutId();

    const handleMapButtonClick = () => {
        if (layoutId === 'Mobile_BottomSheet_WebView_V1') {
            triggerAppBottomSheet('tip');
            return;
        }
    };

    return (
        <MapButtonSticky
            iconUrl={iconUrl}
            linkUrl={linkUrl}
            onClick={handleMapButtonClick}
            position={'fixed'}
            title={title}
        />
    );
}
